import adminHttpService from "../httpServicesAdmin/adminHttpService";
import Swal from "sweetalert2";

export async function adminLogin(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/login`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function adminForgotPass(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/forgotPassword`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function adminChangePass(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/changePassword`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function adminVerifyOtp(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/verifyOTP`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function adminResetPass(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updatePassword`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function UpdateProfile(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateProfile`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// dash api

export async function AllSubjects(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getSubjects`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function AddNewSubject(formData) {
  try {
    const { data } = await adminHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/addSubject`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function DeleteSubject(id) {
  console.log(id);
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/deleteSubject/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function ViewSubject(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewSubject/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function UpdateSubStatus(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateSubjectStatus/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function UpdateStudentStatus(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateStatus/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ViewStudent(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewStudent/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function StudentAnalytics(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getStudentAnalytics`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ExportStudent(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/exportStudents`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ExportExamHistory(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/exportExamHistory`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function GetSchool(formData) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/student/getSchools`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function StudentAllAnalytics(formData) {
  try {
    const { data } = await adminHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getStudentsAnalytics`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function ViewStudentsResult(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getStudentsResult/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function EditSubject(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/editSubject`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function DashboardStats() {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/allStatistics`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function AllStudents(formData, signal) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getAllStudents`,
      formData,
      signal
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// QUESTION PAPER MANAGEMENT

export async function GetYears(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getYears`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function GetPaperTypes(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getPaperTypes`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function GetSessions(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getSessions`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function GetVariants(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getVariants`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function GetQuestions(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getQuestions`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function RegenerateAnswer(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/reGenerateAnswer`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function UpdateAnswer(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateAnswer`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function GetQuestionType(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getQuestionNumbers`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// Teachers

export async function AllTeachers(formData, signal) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getTeachers`,
      formData,
      signal
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ViewTeacher(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewTeacher/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function AcceptRejectTeacher(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/acceptRejectTeacher`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ChangeTeacherStatus(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateTeacherStatus/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// HELP N SUPPORT

export async function ViewSupport(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/supportList`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ChangeSupportStatus(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/supportStatus`,
      formData
    );
    // console.log(data);
    if (data && data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function ViewSupportMessage(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewMessage/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function AdminReply(id, formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/adminReply/${id}`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// SUBSCRIPTION

export async function AddSubscription(formData) {
  try {
    const { data } = await adminHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/createSubscription`,
      formData
    );
    console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function GetSubscription() {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getSubscriptions`
    );
    console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function UpdateSubscriptionStatus(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateSubscriptionStatus/${id}`
    );
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ViewSubscription(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewSubscription/${id}`
    );
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function UpdateSubscription(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateSubscription`,
      formData
    );
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// CONTENT

export async function GetContentData() {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getContent`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function EditContentData(id, formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/editContent/${id}`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// NOTIFICATION

export async function Notifications(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getNotifications`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function DeleteNotification(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/deleteNotification/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ViewNotification(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewNotification/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// PUSH NOTIFICATION

export async function PushNotifications(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getAllNotifications`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function PushNotificationsView(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewNotifications/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function AddPushNotifications(formData) {
  try {
    const { data } = await adminHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/addNotification`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function SendAgain(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/sendAgain/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function DeletePushNotification(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/deletePushNotification/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function UpdateAdminLogo(formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateAdminLogo`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function GetAdminLogo() {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getAdminLogo`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// TRANSACTION

export async function GetTransactions(formData) {
  try {
    const { data } = await adminHttpService.patch(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getTransactions`,
      formData
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ViewTransactions(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/viewTransaction/${id}`
    );
    // console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

// ADD PROMOCODE

export async function AddPromocode(formData) {
  try {
    const { data } = await adminHttpService.post(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/createVoucher`,
      formData
    );
    console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}

export async function GetPromocode() {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getVouchers`
    );
    console.log(data);
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function UpdatePromocodeStatus(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/changeVoucherStatus/${id}`
    );
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function ViewPromocode(id) {
  try {
    const { data } = await adminHttpService.get(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/getVoucherById/${id}`
    );
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
export async function UpdatePromocode(id, formData) {
  try {
    const { data } = await adminHttpService.put(
      `${process.env.REACT_APP_APIENDPOINT}api/admin/updateVoucher`,
      formData
    );
    if (data?.error) {
      Swal.fire({
        title: data?.message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { data };
  } catch (error) {
    if (error.response) {
      console.log(error?.response);
      Swal.fire({
        title: "Error!",
        text: "",
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2e3b5b",
      });
    }
    return { error };
  }
}
